var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webdatalist" },
    [
      _c(
        "f7-list",
        {
          staticClass: "searchbar-found",
          attrs: { "media-list": "", id: "contacts-list" },
        },
        [
          Object.keys(_vm.contacts).length > 0
            ? _c(
                "div",
                _vm._l(_vm.contacts, function (group, key) {
                  return _c(
                    "ul",
                    { key: key },
                    [
                      _c("f7-list-item", {
                        attrs: { title: key, "group-title": "" },
                      }),
                      _vm._v(" "),
                      _vm._l(group, function (contact) {
                        return _c(
                          "li",
                          {
                            key: contact.id,
                            staticClass: "testTap cursor contact-line",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item-content",
                                on: {
                                  click: function ($event) {
                                    return _vm.contactDetail(contact)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-inner contact-list-table my-auto",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(contact.label) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-title contactItem contact-list-table my-auto",
                                  },
                                  [_vm._v(_vm._s(contact.name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-media contact-list-table mr-50px",
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mx-2 btn-contact-list",
                                        attrs: {
                                          variant: "tertiary",
                                          title: _vm.removelabel,
                                          delete: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeContact(
                                              contact,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-light fa-trash",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              )
            : _c("div", { staticClass: "noResult" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("common.no_result")) + "\n    "
                ),
              ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }